import { AxiosError } from 'axios';
import { restApi } from 'src/utilities/restApi';
import { ErrorResponse, SuccessResponse } from 'src/utilities/restApi/common/types/responses';
import { RequestGetSoshikiLeaders, ResponseGetSoshikiLeaders } from 'src/utilities/restApi/shien/types/soshikiLeaders';
import { getCommonHeaders } from 'src/utilities/restApi/utilities/getCommonHeader';

const url = '/soshiki_leaders';

export const getSoshikiLeaders = async (params: RequestGetSoshikiLeaders) => {
  const headers = { headers: await getCommonHeaders() };
  const config = { ...headers };

  return new Promise<SuccessResponse<ResponseGetSoshikiLeaders>>((resolve, reject) => {
    restApi()
      .get<SuccessResponse<ResponseGetSoshikiLeaders>>(`${url}/${params.soshikiidList.join(',')}`, config)
      .then((response) => {
        resolve(response.data!);
      })
      .catch((error: AxiosError<ErrorResponse>) => {
        reject(error.response?.data);
      });
  });
};
